import { KB_RESIST_CAP } from '../physics/constants';
import type { GameMode } from '../types';

/** How a game mode treats runes. */
export interface RuneRules {
  /** Runes can be unlocked and swapped in the shop. */
  shop: boolean;
  /** Unlocked runes can be swapped on the respawn screen (Deathmatch). */
  swapOnRespawn: boolean;
  /** Every rune is unlocked for free (Avatar). */
  allUnlocked: boolean;
}

const STANDARD: Readonly<RuneRules> = Object.freeze({
  shop: true,
  swapOnRespawn: false,
  allUnlocked: false,
});

/**
 * Rune rules per game mode (DROW-140 §5). FFA and Teams use the shop. Deathmatch, Random Spells
 * (runes off) and Avatar (all unlocked) add their rows here when those modes are built.
 */
export function runeRules(mode: GameMode | (string & {})): RuneRules {
  switch (mode) {
    case 'ffa':
    case 'teams':
    default:
      return STANDARD;
  }
}

/** A player's Emberward timer, as synced. */
export interface WardTimer {
  wardUntil?: number;
}

/** Knockback resist while Emberward is up (`RUNES.emberward` `lavaWard.kbResist`). */
export const EMBERWARD_KB_RESIST = 0.4;

/** Whether `p`'s Emberward is up at `now` (server clock ms). */
export function wardUp(p: WardTimer, now: number): boolean {
  return (p.wardUntil ?? 0) > now;
}

/** Multiplier on lava damage `p` takes at `now`: 0 while Emberward is up, else 1. */
export function lavaMultAt(p: WardTimer, now: number): number {
  return wardUp(p, now) ? 0 : 1;
}

/** Knockback resist R for `computeKnockback` at `now`: Emberward's, capped at KB_RESIST_CAP. */
export function kbResistAt(p: WardTimer, now: number): number {
  return Math.min(KB_RESIST_CAP, wardUp(p, now) ? EMBERWARD_KB_RESIST : 0);
}
